import {Button, HStack, Link, Text, useTheme, VStack} from '@chakra-ui/react'
import {faCheck} from '@fortawesome/pro-regular-svg-icons'
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {ReactNode} from 'react'
import InfoWIcon from './InfoWIcon'
import {CEDILLE_CONTACT, getCedilleRedirectURL} from '../../constants/routes'
import {useRouter} from 'next/router'
import useTranslation from 'next-translate/useTranslation'

interface Props {
  onClick?: () => void
  customIcon?: ReactNode
  preferred?: boolean
  points: {text: string}[]
}

const PriceBlock = ({onClick, customIcon, points}: Props) => {
  const theme = useTheme()
  const router = useRouter()
  const {t} = useTranslation('subscription')

  return (
    <VStack
      spacing={8}
      w='full'
      p={6}
      background={theme.colors.layers.appLevel2}
      borderRadius={theme.radii.medium}
      h='full'
      justifyContent='space-between'
      alignItems='start'>
      <VStack w='full' spacing={7}>
        <InfoWIcon
          mainText={t('subscription_plan_custom_price')}
          customIcon={customIcon}
          header={t('subscription_plan_custom')}
          smallText=''
        />
        <VStack align='start' w='full' spacing={3}>
          {points.map((point, index) => (
            <HStack spacing={2.5} key={index}>
              <FontAwesomeIcon
                width={15}
                height={15}
                icon={faCheck}
                color={theme.colors.text.light}
              />
              <Text color={theme.colors.text.light} variant='small'>
                {point.text}
              </Text>
            </HStack>
          ))}
        </VStack>
      </VStack>
      <Link href={getCedilleRedirectURL(CEDILLE_CONTACT, router.locale)} isExternal w='full'>
        <Button
          variant='primary'
          rightIcon={<FontAwesomeIcon icon={faPaperPlane} />}
          w={['full', null, null, 'auto']}>
          {t('pricing_custom_button')}
        </Button>
      </Link>
    </VStack>
  )
}

export default PriceBlock
